import React, { useEffect, useState } from 'react';
import { apiDriverApp } from '../../../../libs/apiDriverApp';
import 'semantic-ui-css/semantic.min.css';
import './styles.css';
import { WeeklyView } from '../components/weeklySchedule/WeeklyView';
import ManagementView from '../components/weeklySchedule/shiftManagement/ManagementView';
import { DefaultScheduleView } from '../components/weeklySchedule/DefaultScheduleView';
import { ScheduleManagement } from '../components/schedule-management/ScheduleManagement';
import { NavMenu } from './NavMenu/NavMenu';

export const Schedules = () => {
   const [options, setOptions] = useState([]);
   const [shifts, setShifts] = useState([]);
   const [active, setActive] = useState('Weekly Schedules');
   const [stations, setStations] = useState([]);

   const formatShifts = (shifts) => {
      let SelectOptions = shifts.map((shift) => {
         return {
            value: shift.name,
            label: shift.name,
            id: shift.id,
         };
      });
      SelectOptions.unshift({
         value: 'None',
         label: 'None',
      });
      return SelectOptions;
   };

   const getShiftsforSelect = async () => {
      try {
         const { data } = await apiDriverApp.get('api/hr/shifts/');
         setShifts(data);
         setOptions(formatShifts(data));
      } catch (error) {
         setOptions(formatShifts([]));
      }
   };

   const getStations = async () => {
      try {
         const { data } = await apiDriverApp.get('api/hr/stations/');
         setStations(data);
      } catch (error) {
         console.log(error);
      }
   };

   useEffect(() => {
      getShiftsforSelect();
      getStations();
   }, []);

   return (
      <React.Fragment>
         <NavMenu active={active} setActive={setActive} />
         <div style={{ display: 'flex', flexDirection: 'column', padding: '0 75px 50px 75px' }}>
            <div key={active} className="fade-in">
               <div className="d-flex justify-content-between align-items-center mb-3">
                  <h3>
                     {active === 'All Schedules'
                        ? 'Schedules - All'
                        : active === 'Weekly Schedules'
                        ? 'Schedules - Weekly'
                        : 'Shift Management'}
                  </h3>
               </div>

               {active === 'All Schedules' ? (
                  //   <DefaultScheduleView options={options}/>
                  <ScheduleManagement />
               ) : active === 'Weekly Schedules' ? (
                  <WeeklyView shifts={shifts} stations={stations} />
               ) : (
                  <ManagementView options={options} />
               )}
            </div>
         </div>
      </React.Fragment>
   );
};
